// import variables from '../variables';
/* eslint-disable */
import { createTheme } from '@material-ui/core/styles';
// https://stackoverflow.com/questions/51519246/override-components-like-muitab-that-use-media-queries
let theme = createTheme({});
const MuiTableCell = {
  root: {
    // backgroundColor: 'lightblue',
  },
  head: {
    fontWeight: 700,
    fontSize: 14,
  },
  body: {
    fontWeight: 500,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
};

export default MuiTableCell;
